import {nest, withProps,} from 'recompose'
import {DelayRender} from 'views/Shared/components/DelayRender'
import {organizationPermissionCodes} from 'modules/permissions/contants'
import React, {useCallback, useContext, useMemo} from 'react'
import {createCheckPermissions,} from 'views/AppLocals/factory/createCheckPermissions'
import {SettingsMenu} from 'views/AppLocals/factory/createSettingLayout'
import {renderOwnChild} from 'views/Shared'
import CustomSiderMenu from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceContext from "../WorkspaceContext";
import useTranslate from "../../../modules/local/useTranslate";
import {PiMonitorLight, PiUsersFourLight, PiUsersThreeLight} from "react-icons/pi";
import {MdAccountTree} from "react-icons/md";
import WorkspaceMemberDashboard from "../Member/WorkspaceMemberDashboard";
import WorkspaceOrganizationMemberDetail from "../Member/WorkspaceOrganizationMemberDetail";
import WorkspaceOrgDeptContainer from "../Member/WorkspaceOrgDeptContainer";
import WorkspaceOrganizationGroupTree from "../Member/WorkspaceOrganizationGroupTree";
import WorkspaceGoverningOrganizations from "./WorkspaceGoverningOrganizations";
import WorkspaceSubordinateUnits from "./WorkspaceSubordinateUnits";
import HostRelatedEvents from "./HostRelatedEvents";
import WorkspaceHostPeerMembers from "./WorkspaceHostPeerMembers";
import UnderDevelopment from "../../Shared/components/UnderDevelopment";
import WorkspaceMemberPersonalProfile from "../Member/WorkspaceMemberPersonalProfile";

const ItemKeys = Object.freeze({
    DASHBOARD: 'dashboard',
    MEMBERS: 'members',
    WAITING_MEMBERS: 'waiting-members',
    INVITES: 'invites',
    ORGANIZATION_MEMBERS: 'org-members',
    ORGANIZATION_MEMBERS_LIST: 'org-members-list',
    WAITING_ORGANIZATION_MEMBERS: 'waiting-org-members',
    ORGANIZATION_INVITES: 'org-invites',
    ORGANIZATION_GROUPS: 'org-groups',

    GOVERNING_ORGANIZATIONS: 'governing_organizations',
    SUBORDINATE_UNITS: 'subordinate_units',
    RELATED_EVENTS: 'related-events',
    PEER_MEMBERS: 'peer-members',
    PEER_MEMBERS_GROUP: 'peer-members-group',
    ACT_GROUP: 'act-group',

    // new layout items
    PERSONAL_PROFILE:     'personal-profile',
    CG_FAMILY_BOOK:       'cg-family-book',
    ORG_TREE:             'org-tree',
    MEMBER_ANNIVERSARIES: 'member-anniversaries',
    AGE_GROUP:            'age-group',
    FAMILY_SITUATION:     'family-situation',
});


export const OrganizationActionTypes = Object.freeze({
    DEPT_CREATE: 'dept-create',
    DEPT_UPDATE: 'dept-update',
    DEPT_DELETE: 'dept-delete',
    DEPT_ADD_MEMBER: 'dept-add-member',
    DEPT_ADD_ORG_MEMBER: 'dept-add-org-member',
    DEPT_EDIT_MEMBER: 'dept-edit-member',
    DEPT_DELETE_MEMBER: 'dept-delete-member',
    DEPT_MEMBER_SET_ACTIVE: 'dept-member-set-active',
})


const WorkspaceMemberContent = () => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext);
    const menuItems = useMemo(() => {
        return [
            {
                key: ItemKeys.DASHBOARD,
                label: 'overview',
                icon: <PiMonitorLight size={16}/>,
            },
            {
                key: 'org-depts-group',
                label: 'groups / ministries',
                icon: <PiUsersFourLight size={16}/>,
                children: [
                    {
                        key: ItemKeys.ORGANIZATION_GROUPS,
                        label: 'list of group / ministry',
                        icon: <PiUsersFourLight size={15}/>,
                    },
                    {
                        key: ItemKeys.ORG_TREE,
                        label: 'org tree',
                        icon: <MdAccountTree size={15}/>,
                    },
                ],
            },
            {
                key: ItemKeys.ORGANIZATION_MEMBERS,
                label: 'members',
                icon: <PiUsersThreeLight size={16}/>,
            },
        ];
    }, [])
    const routeEntities = useMemo(() => {
        return [
            {
                key: ItemKeys.DASHBOARD,
                component: WorkspaceMemberDashboard,
            },
            {
                key: ItemKeys.ORGANIZATION_GROUPS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(WorkspaceOrgDeptContainer),
            },
            {
                key: ItemKeys.ORGANIZATION_MEMBERS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(WorkspaceOrganizationMemberDetail),
            },
            {
                key: ItemKeys.GOVERNING_ORGANIZATIONS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageStructure,
                ])(WorkspaceGoverningOrganizations),
            },
            {
                key: ItemKeys.SUBORDINATE_UNITS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageStructure,
                ])(WorkspaceSubordinateUnits),
            },
            {
                key: ItemKeys.RELATED_EVENTS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(HostRelatedEvents),
            },
            {
                key: ItemKeys.PEER_MEMBERS,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManagePeerStructure,
                ])(WorkspaceHostPeerMembers),
            },
            { key: ItemKeys.PERSONAL_PROFILE,     component: WorkspaceMemberPersonalProfile },
            { key: ItemKeys.CG_FAMILY_BOOK,       component: UnderDevelopment },
            {
                key: ItemKeys.ORG_TREE,
                component: createCheckPermissions([
                    organizationPermissionCodes.organizationManageMember,
                ])(WorkspaceOrganizationGroupTree),
            },
            { key: ItemKeys.MEMBER_ANNIVERSARIES, component: UnderDevelopment },
            { key: ItemKeys.AGE_GROUP,            component: UnderDevelopment },
            { key: ItemKeys.FAMILY_SITUATION,     component: UnderDevelopment },
        ].map(({key, ...rest}) => ({
            key,
            path: key,
            ...rest,
        }));
    }, [])

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    const renderMenu = useCallback(
        () => (
            <CustomSiderMenu
                deps={[activeKey]}
                Wrapper={renderOwnChild}>
                <SettingsMenu
                    items={menuItems}
                    onSelect={onMenuSelect}
                    selectedKeys={[activeKey]}
                    // defaultSelectedKeys={[activeKey]}
                    defaultOpenKeys={[]}
                />
            </CustomSiderMenu>
        ),
        [menuItems, activeKey]
    )

    return (
        <div className="px-3 md:px-6">
            <Component/>
        </div>
    )
}

export default nest(
    withProps({lazy: true})(
        DelayRender
    ),
    WorkspaceMemberContent
)
